export default [{
    "name": "北京市",
    "adcode": "110000",
    "citycode": "010",
    "proname": "北京市",
    "center": "116.407394,39.904211",
  },
  {
    "name": "上海市",
    "adcode": "310000",
    "citycode": "021",
    "proname": "上海市",
    "center": "121.473662,31.230372",
  },
  {
    "name": "天津市",
    "adcode": "120000",
    "citycode": "022",
    "proname": "天津市",
    "center": "117.200983,39.084158",
  },
  {
    "name": "重庆市",
    "adcode": "500000",
    "citycode": "023",
    "proname": "重庆市",
    "center": "106.551643,29.562849",
  },
  {
    "name": "哈尔滨市",
    "adcode": "230100",
    "citycode": "0451",
    "proname": "黑龙江省",
    "center": "126.661665,45.742366",
  },
  {
    "name": "长春市",
    "adcode": "220100",
    "citycode": "0431",
    "proname": "吉林省",
    "center": "125.32568,43.897016",
  },
  {
    "name": "沈阳市",
    "adcode": "210100",
    "citycode": "024",
    "proname": "辽宁省",
    "center": "123.431382,41.836175",
  },
  {
    "name": "呼和浩特市",
    "adcode": "150100",
    "citycode": "0471",
    "proname": "内蒙古自治区",
    "center": "123.431382,41.836175",
  },
  {
    "name": "石家庄市",
    "adcode": "130100",
    "citycode": "0311",
    "proname": "河北省",
    "center": "114.530235,38.037433",
  },
  {
    "name": "乌鲁木齐市",
    "adcode": "650100",
    "citycode": "0991",
    "proname": "新疆维吾尔自治区",
    "center": "87.627704,43.793026",
  },
  {
    "name": "兰州市",
    "adcode": "620100",
    "citycode": "0931",
    "proname": "甘肃省",
    "center": "108.954347,34.265502",
  },
  {
    "name": "西宁市",
    "adcode": "630100",
    "citycode": "0971",
    "proname": "青海省",
    "center": "101.780268,36.620939",
  },
  {
    "name": "西安区",
    "adcode": "220403",
    "citycode": "0437",
    "proname": "陕西省",
    "center": "108.954347,34.265502",
  },
  {
    "name": "银川市",
    "adcode": "640100",
    "citycode": "0951",
    "proname": "宁夏回族自治区",
    "center": "106.259126,38.472641",
  },
  {
    "name": "郑州市",
    "adcode": "410100",
    "citycode": "0371",
    "proname": "河南省",
    "center": "113.753394,34.765869",
  },
  {
    "name": "济南市",
    "adcode": "370100",
    "citycode": "0531",
    "proname": "山东省",
    "center": "117.019915,36.671156",
  },
  {
    "name": "太原市",
    "adcode": "140100",
    "citycode": "0351",
    "proname": "山西省",
    "center": "112.562678,37.873499",
  },
  {
    "name": "合肥市",
    "adcode": "340100",
    "citycode": "0551",
    "proname": "安徽省",
    "center": "117.329949,31.733806",
  },
  {
    "name": "武汉市",
    "adcode": "420100",
    "citycode": "027",
    "proname": "湖北省",
    "center": "114.341745,30.546557",
  },
  {
    "name": "长沙市",
    "adcode": "430100",
    "citycode": "0731",
    "proname": "湖南省",
    "center": "112.9836,28.112743",
  },
  {
    "name": "南京市",
    "adcode": "320100",
    "citycode": "025",
    "proname": "江苏省",
    "center": "118.762765,32.060875",
  },
  {
    "name": "成都市",
    "adcode": "510100",
    "citycode": "028",
    "proname": "四川省",
    "center": "104.075809,30.651239",
  },
  {
    "name": "贵阳市",
    "adcode": "520100",
    "citycode": "0851",
    "proname": "贵州省",
    "center": "106.70546,26.600055",
  },
  {
    "name": "昆明市",
    "adcode": "530100",
    "citycode": "0871",
    "proname": "云南省",
    "center": "102.710002,25.045806",
  },
  {
    "name": "南宁市",
    "adcode": "450100",
    "citycode": "0771",
    "proname": "广西壮族自治区",
    "center": "108.327546,22.815478",
  },
  {
    "name": "拉萨市",
    "adcode": "540100",
    "citycode": "0891",
    "proname": "西藏自治区",
    "center": "91.117525,29.647535",
  },
  {
    "name": "杭州市",
    "adcode": "330100",
    "citycode": "0571",
    "proname": "浙江省",
    "center": "120.152585,30.266597",
  },
  {
    "name": "南昌市",
    "adcode": "360100",
    "citycode": "0791",
    "proname": "江西省",
    "center": "115.81635,28.63666",
  },
  {
    "name": "广州市",
    "adcode": "440100",
    "citycode": "020",
    "proname": "广东省",
    "center": "113.26641,23.132324",
  },
  {
    "name": "福州市",
    "adcode": "350100",
    "citycode": "0591",
    "proname": "福建省",
    "center": "119.295143,26.100779",
  },
  {
    "name": "台湾省",
    "adcode": "710000",
    "citycode": "1886",
    "proname": "台湾省",
    "center": "121.509062,25.044332",
  },
  {
    "name": "海口市",
    "adcode": "460100",
    "citycode": "0898",
    "proname": "海南省",
    "center": "110.349228,20.017377",
  },
  {
    "name": "香港特别行政区",
    "adcode": "810000",
    "citycode": "1852",
    "proname": "香港特别行政区",
    "center": "114.171203,22.277468",
  },
  {
    "name": "澳门特别行政区",
    "adcode": "820000",
    "citycode": "1853",
    "proname": "澳门特别行政区",
    "center": "113.543028,22.186835",
  },
]